/**
 * Created by Karol Kluska on 09.10.17.
 */
angular
  .module('app')
  .component('languageDropdown', {
    templateUrl: 'app/components/bookingEngine/header/headerDropdown/Language.html',
    controller: Language,
    bindings: {
      languages: '<',
      onChange: '&'
    }
  });

/** @ngInject */
function Language($translate) {
  var $this = this;
  $this.$translate = $translate;
  $this.currentLanguageCode = $translate.use();
  $this.systemLanguages = [
    {
      code: 'en',
      img: 'be/assets/img/flags/en-min.png',
      name: 'English'
    },
    {
      code: 'de',
      img: 'be/assets/img/flags/de-min.png',
      name: 'Deutsch'
    },
    {
      code: 'ru',
      img: 'be/assets/img/flags/ru-min.png',
      name: 'Pусский'
    },
    {
      code: 'fr',
      img: 'be/assets/img/flags/fr-min.png',
      name: 'Français'
    },
    {
      code: 'it',
      img: 'be/assets/img/flags/it-min.jpg',
      name: 'Italian'
    },
    {
      code: 'es',
      img: 'be/assets/img/flags/es-min.png',
      name: 'Spanish'
    },
    {
      code: 'uk',
      img: 'be/assets/img/flags/uk-min.png',
      name: 'Ukrainian'
    },
    {
      code: 'lv',
      img: 'be/assets/img/flags/lv-min.png',
      name: 'Latvian'
    },
    {
      code: 'pl',
      img: 'be/assets/img/flags/pl-min.png',
      name: 'Polski'
    },
    {
      code: 'gr',
      img: 'be/assets/img/flags/el-min.png',
      name: 'Ελληνικα'
    },
    {
      code: 'no',
      img: 'be/assets/img/flags/no-min.png',
      name: 'Norsk'
    }
  ];
  $this.activeLanguage = $this.systemLanguages.find(function (lang) {
    return lang.code === $this.currentLanguageCode;
  });
}

Language.prototype = {
  $onInit: function () {
    this.availableLanguages = this.getAvailableLanguages();
  },

  handleChange: function (langCode) {
    this.$translate.use(langCode);
    this.onChange({langCode: langCode});
  },

  getAvailableLanguages: function () {
    var result = [];
    for (var i = 0; i < this.systemLanguages.length; i++) {
      var lang = this.systemLanguages[i];
      if (this.languages.indexOf(lang.code) !== -1) {
        result.push(lang);
      }
    }
    if (result.length === 0) {
      result.push(this.systemLanguages[0]);
    }
    return result;
  }
};
